var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.9 155.9",
    style: {
      enableBackground: "new 0 0 155.9 155.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#199436;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,129.9l7.6-27.1c-4.9-8.3-7.5-17.8-7.5-27.5c0-30,24.4-54.4,54.4-54.4s54.4,24.4,54.4,54.4 s-24.4,54.4-54.4,54.4c-9.3,0-18.5-2.4-26.6-6.9L26.6,129.9z M55.9,112.8l1.7,1c7.1,4.3,15.2,6.6,23.5,6.6 c24.9,0,45.1-20.3,45.1-45.1S106,30.1,81.1,30.1S35.9,50.4,35.9,75.3c0,8.7,2.5,17.1,7.1,24.4l1.1,1.7L39.8,117L55.9,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.8,50l-3.5-0.2c-1.1-0.1-2.2,0.3-3,1c-1.7,1.5-4.4,4.4-5.3,8.1c-1.3,5.6,0.7,12.4,5.7,19.2 c5,6.8,14.3,17.8,30.9,22.4c5.3,1.5,9.5,0.5,12.7-1.6c2.6-1.6,4.3-4.3,5-7.2l0.6-2.6c0.2-0.8-0.2-1.7-1-2l-11.9-5.5 c-0.8-0.4-1.7-0.1-2.2,0.5l-4.7,6.1c-0.4,0.5-1,0.6-1.5,0.4c-3.2-1.1-13.9-5.6-19.8-17c-0.3-0.5-0.2-1.1,0.2-1.5l4.5-5.2 c0.5-0.5,0.6-1.3,0.3-1.9l-5.1-12C67.1,50.4,66.5,50,65.8,50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.4a0db9de979b8177d338d960e840e067.svg";
export { ForwardRef as ReactComponent };